import React, { Component, Fragment } from 'react';

class Pagination extends Component {

    clickPage(page, e) {
        e.preventDefault();
        this.props.clickPage(page);
    }

    clickDisabled(e) {
        e.preventDefault();
    }

    render() {
        let {page, number_page} = this.props;
        if (number_page < 2) return '';
        return (
            <div className="text-center">
                <ul className="list-inline pagination-kt">
                    {page == 1 && (
                        <li>
                            <a href="#" className="disabled" onClick={this.clickDisabled.bind(this)}>
                                <span className="fa fa-angle-left"></span>
                            </a>
                        </li>
                    )}
                    {page > 1 && (
                        <Fragment>
                            <li>
                                <a href="#" onClick={this.clickPage.bind(this, page - 1)}>
                                    <span className="fa fa-angle-left"></span>
                                </a>
                            </li>
                            {page > 2 && <li><a href="#" onClick={this.clickPage.bind(this, page - 2)}>{page - 2}</a></li>}
                            <li><a href="#" onClick={this.clickPage.bind(this, page - 1)}>{page - 1}</a></li>
                        </Fragment>
                    )}
                   
                    <li><a href="#" className="active">{page}</a></li>

                    {page < number_page && (
                        <Fragment>
                            <li><a href="#" onClick={this.clickPage.bind(this, page + 1)}>{page + 1}</a></li>
                            {page + 1 < number_page && <li><a href="#" onClick={this.clickPage.bind(this, page + 2)}>{page + 2}</a></li>}
                            <li>
                                <a href="#" onClick={this.clickPage.bind(this, page + 1)}>
                                    <span className="fa fa-angle-right" role="button"></span>
                                </a>
                            </li>
                            
                        </Fragment>
                    )}

                    {page == number_page && (
                        <li>
                            <a href="#" className="disabled" onClick={this.clickDisabled.bind(this)}>
                                <span className="fa fa-angle-right" role="button"></span>
                            </a>
                        </li>
                    )} 
                    
                </ul>
            </div>
        );
    }
}

export default Pagination;